import { Component, OnInit, ViewChild, ElementRef, Inject, Renderer2, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from '../../pages/auth/UserDetails/user.service';
import { GlobalStorage } from '../../../core/Gloabl/Global';
import { ProfileService } from 'src/app/modules/profile-module/profile.service';
import { Notification } from 'src/app/core/Notifications/Notification';
import { HospitalService } from 'src/app/core/services/hospital.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  userdata: any = {
    rolename: '',
    firstName: '',
    email: '',
    imagename: ''
  };
  image_Url: any;
  test: any = 'Welcome Test';
  message: any;

  //hospital dropdown at top level
  hospitalList: any[] = [];
  //selectedHospital:any;
  selectedHospitalId: any;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private user: UserService,
    private store: GlobalStorage,
    private notif: Notification,
    private service: ProfileService,
    private hospitalService: HospitalService
  ) { }

  ngOnInit(): void {
    this.service.currentUserImage.subscribe(data => {
      console.log('Test image')
      console.log(data)
      if (data != undefined) {
        this.image_Url = data;
      }
    })
    this.get_profile();


  }

  receivename($event: string) {
    this.test = $event;
  }

  toggleSidebar(e:any) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }



  onLogout(e:any) {
    e.preventDefault();
    this.user.logout();
    this.router.navigate(['/auth/login']);
    this.notif.successmsg("User Logged out Successfully")
  }

  get_profile() {
    this.service.Get_Userprofile().subscribe({
      next: (res: any) => {
        console.log('Profile Data', res);

        this.userdata = res;

        this.image_Url = res?.imagename
          ? res.imagename
          : 'assets/images/default-profile.png';
        //load hospitals on header
        this.loadHospitals();
      },
      error: (err) => {
        console.error('Profile API Error', err);

        this.userdata = {
          rolename: '',
          firstName: '',
          email: ''
        };

        this.image_Url = 'assets/images/default-profile.png';
      }
    });
  }


  loadHospitals() {

    this.service.GetAllHospital().subscribe({

      next: (res: any[]) => {

        if (this.userdata.rolename === 'ADMIN') {

          // Admin can see all hospitals
          this.hospitalList = res;

          // Check if already selected
          const saved = this.hospitalService.getHospital();

          if (saved) {

            this.selectedHospitalId = saved.hos_Id;

          } else {

            const defaultHospital = res.find(x => x.hos_Id == 638) || res[0];

            this.selectedHospitalId = defaultHospital.hos_Id;

            this.hospitalService.changeHospital(defaultHospital);

          }


        }

        else if (this.userdata.rolename === 'HOSPITAL ADMIN') {

          // Hospital Admin can see only own hospital

          this.hospitalList = res.filter(
            x => x.hos_Id == this.userdata.hospitalId_FK
          );

          /*
          this.selectedHospitalId = this.hospitalList[0];
          this.hospitalService.changeHospital(this.selectedHospitalId);
          */
          const hospital = this.hospitalList[0];

          this.selectedHospitalId = hospital.hos_Id;

          this.hospitalService.changeHospital(hospital);

        }

      }

    });

  }

  onHospitalChange() {

    const hospital = this.hospitalList.find(
      x => x.hos_Id == this.selectedHospitalId
    );

    if (hospital) {

      this.hospitalService.changeHospital(hospital);

      window.location.reload();

    }

  }

}